export default __webpack_public_path__ + "static/media/signout.59bb971e.png";